import { useEffect } from 'react';

import Container from 'layout/atoms/Container';
import ContentBox from 'layout/atoms/ContentBox';

import IllustrationExecute from 'assets/illustrations/empty-execute.webp';

export const EmptyState = () => {
    useEffect(() => {}, []);

    return (
        <Container size="s" marginTop="16">
            <ContentBox>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        src={IllustrationExecute}
                        alt=""
                        style={{ maxWidth: '200px' }}
                    />
                    <h3
                        style={{
                            margin: '0 0 12px 0',
                            fontSize: '20px',
                            fontWeight: '600',
                            color: 'var(--text)',
                        }}
                    >
                        Ready to execute!
                    </h3>
                    <p
                        style={{
                            margin: '0 0 24px 0',
                            fontSize: '16px',
                            lineHeight: '1.5',
                            color: 'var(--text)',
                            opacity: 0.7,
                            maxWidth: '400px',
                        }}
                    >
                        No planned tasks yet. Time to relax! Add tasks from your
                        planning workspace or use Quick Add above.
                    </p>
                    <div
                        style={{
                            fontSize: '14px',
                            color: 'var(--text)',
                            opacity: 0.6,
                            fontWeight: '500',
                        }}
                    >
                        ☝️ Use Quick Add above to get started
                    </div>
                </div>
            </ContentBox>
        </Container>
    );
};

export default EmptyState;
